export default "__VITE_ASSET__C1_Qp5VB__"